import { Timestamp } from 'firebase/firestore';
import { UserProfile } from '../types/user';

export const createDefaultUserProfile = (
  id: string,
  name: string,
  email: string,
  avatar: string
): UserProfile => {
  return {
    id,
    name,
    email,
    avatar,
    role: 'member',
    status: 'active',
    createdAt: Timestamp.now(),
    updatedAt: Timestamp.now(),
    lastActive: Timestamp.now(),
    stats: {
      eventsCreated: 0,
      eventsAttended: 0,
      commentsPosted: 0,
      reportsSubmitted: 0,
      eventsRSVPd: 0,
      pollsCreated: 0,
      pollVotes: 0,
    },
    preferences: {
      notifications: true,
      theme: 'dark'
    }
  };
}; 